<template>
  <AllegroJsonForm
    title="Allegro - Dodaj informację o bezpieczeństwie produktu"
    crumbLabel="Dodawanie informacji o bezpieczeństwie produktu"
    :settingsCrumb="true"
    submitAction="createAllegroSafetyInformation"
    submitGetter="getAllegroSafetyInformationCreateData"
    backRoute="/allegro/accounts"
    accountPkParam="pk"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroSafetyInformationPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroSafetyInformationCreate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroSafetyInformationPermissionsConst.add,
      fields: [
        {
          key: "text",
          label: "Opis bezpieczeństwa",
          type: "textarea",
          required: true,
        },
      ],
    };
  },
};
</script>
